'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Close;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'next';

function Close(_ref) {
  var handleClick = _ref.handleClick;

  return _react2.default.createElement(
    'a',
    {
      className: CLASS_NAME + ' button-link secondary',
      onClick: function onClick() {
        return handleClick();
      }
    },
    'Next \u203A'
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/Matcher/components/Next.jsx
// module id = 1238
// module chunks = 0